module.exports = __webpack_public_path__ + "media/images/puzzle-2d33caedd99b95dd053df6bf419b676b.svg";